import React from "react";

const BlogItem = () => {
  return (
    <div className="Container-fluid m-3 p-2">
      <div data-aos="zoom-in-up" className="container">
        <div className="Blog-custom-card mb-5">
          <div className="Blog-custom-card-img mb-3">
            <img className="img-fluid"
              src="https://i.ibb.co/BGgzpby/naimdev-medium-com-uses-Bootstrap.png"
              alt="blog"
            />
          </div>
          <h4 className="card-title text-white">
            Uses of Bootstrap in React App for Beginners
          </h4>
          <h6 className="card-desc text-light mb-4">
            Hey mate! I know you are looking for something, which is common for
            every beginner out there. Even me, when I have started to use react
            this is one of the concerns for me. enough talk let’s do it:-
            1.BootstrapCDN: I think the easiest way to use bootstrap for the
            first time in your React app is to use the CDN link. I know, I know
            it's a bit confusing where you will put that CDN link just put it to
            your React app inside the Public folder, go to the index.html file
            put the link in the head tag. I have added inside the index.html
            into the head tag the bootstrap CDN after the title tag. Simply put
            the CDN link into the head section of your app, as shown in the
            following snippet. 
            <br/>
            Read more...
          </h6>
          <a
            href="https://naimdev.medium.com/uses-of-bootstrap-in-react-app-for-beginners-9c19d648bb68"
            target="_blank"
            rel="noopener noreferrer"
            className="live-site-link text-white btn btn-secondary btn-outline-info ml-3"
          >
            Visit Medium
          </a>
        </div>
      </div>

      <h3 className="blogDisplay-1 text-white text-center">More Coming soon...</h3>
      <h4 className="text-center text-white">Thank you</h4>
    </div>
  );
};
export default BlogItem;
